import React from 'react';

import {DownloadAccountActivityForm} from 'app/account/components/AccountOverviewPage/DownloadAccountActivityForm';
import {TransferOwnershipForm} from 'app/account/components/AccountOverviewPage/TransferOwnershipForm';
import {AccountPageShell} from 'app/account/components/AccountPageShell';
import {useCurrentUserState} from 'app/current-user/api';
import {gt} from 'app/utils/i18n';

import {CompanyInformation} from './CompanyInformation';
import {NewMembersBulk} from './NewMembersBulk';
import {SocialAuth} from './SocialAuth';
import {Tour} from './Tour';
import {UserProfile} from './UserProfile';

export function OverviewPage() {
  const {is_owner, is_super_manager, restrict_saml_only_login} =
    useCurrentUserState().data!;
  return (
    <AccountPageShell
      title={gt('Account Overview')}
      location="index"
      isLoading={false}
      error={undefined}
      content={''}
    >
      {() => (
        <>
          <CompanyInformation />
          <NewMembersBulk />
          <UserProfile />
          <Tour />
          <SocialAuth />
          {is_super_manager ? <DownloadAccountActivityForm /> : null}
          <TransferOwnershipForm
            isOwner={is_owner}
            isSamlOnly={restrict_saml_only_login}
          />
        </>
      )}
    </AccountPageShell>
  );
}
